var render = function render(_c,_vm){return (_vm.props.svg)?_c('svg',_vm._b({staticClass:"c-umbraco-svg",class:{
		'c-umbraco-svg--colorize': !_vm.props.keepColors,
	},attrs:{"xmlns":"http://www.w3.org/2000/svg"},domProps:{"innerHTML":_vm._s(_vm.props.svg.content)}},'svg',_vm.props.svg.attrs || {},false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }